import $i18n from 'panda-i18n';

// AGV
// 收货上架时间
const RECEIVING_TIME = [
  {
    label: $i18n.get({ id: 'Created.four_px', dm: '创建时间' }),
    value: 'createTime',
  },

  {
    label: $i18n.get({ id: 'CompletionTime.four_px', dm: '完成时间' }),
    value: 'completeTime',
  },
];

// AGV收货TAB
const RECEIVING_TAB_STATUS = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: $i18n.get({ id: 'InProgress.four_px', dm: '进行中' }),
    value: 'G',
  },

  {
    label: $i18n.get({ id: 'Completed.four_px', dm: '已完成' }),
    value: 'F',
  },

  {
    label: $i18n.get({ id: 'Canceled.four_px', dm: '已取消' }),
    value: 'X',
  },
];

// 收货上架单号
const RECEIVING_ORDER = [
  {
    label: $i18n.get({ id: 'AgvReceivingAndShelvingOrder.four_px', dm: 'AGV收货上架订单' }),
    value: 'agvNo',
  },

  {
    label: $i18n.get({ id: 'InboundOrder.four_px', dm: '入库订单' }),
    value: 'consignmentNo',
  },

  {
    label: $i18n.get({ id: 'WorkOrder.four_px', dm: '收货作业单' }),
    value: 'receiveJobNo',
  },

  {
    label: $i18n.get({ id: 'ShelvingWorkList.four_px', dm: '上架作业单' }),
    value: 'putawayJobNo',
  },
];

const RECEIVING_PERSON_TYPE = [
  {
    label: $i18n.get({ id: 'Founder.four_px', dm: '创建人' }),
    value: 'creatorCode',
  },

  {
    label: $i18n.get({ id: 'Operator.four_px', dm: '操作人' }),
    value: 'operatorCode',
  },
];

// 推送状态
const RECEIVING_PUSH_STATUS = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: 'all',
  },

  {
    label: $i18n.get({ id: 'PushedSuccessfully.four_px', dm: '推送成功' }),
    value: '0',
  },

  {
    label: $i18n.get({ id: 'PushFailed.four_px', dm: '推送失败' }),
    value: '1',
  },

  {
    label: $i18n.get({ id: 'FeedbackSuccessful.four_px', dm: '反馈成功' }),
    value: '3',
  },

  {
    label: $i18n.get({ id: 'FeedbackFailed.four_px', dm: '反馈失败' }),
    value: '4',
  },
];

// 操作内容
const RECEIVING_OPERATION_NODE = [
  {
    label: $i18n.get({ id: 'ReceiveAgvOrderFeedback.four_px', dm: '接收AGV订单反馈' }),
    value: '0',
  },

  {
    label: $i18n.get({ id: 'PushAgvOrders.four_px', dm: '推送AGV订单' }),
    value: '1',
  },

  {
    label: $i18n.get({ id: 'CancelAnAgvOrder.four_px', dm: '取消AGV订单' }),
    value: '2',
  },

  {
    label: $i18n.get({ id: 'CancelAgvRejection.four_px', dm: 'AGV拒单取消' }),
    value: '3',
  },

  {
    label: $i18n.get({ id: 'CustomerCancelsAgvOrder.four_px', dm: '客户取消AGV订单' }),
    value: '4',
  },

  {
    label: $i18n.get({ id: 'CancelAgvRejection.four_px', dm: 'AGV拒单取消' }),
    value: '5',
  },
];

// 操作内容
const STOCK_ADJUST_OPERATION_NODE = [
  {
    label: $i18n.get({ id: 'InventoryAdjustmentOrderFeedback.four_px', dm: '库存调整单反馈' }),
    value: '0',
  },

  {
    label: $i18n.get({ id: 'PushInventoryAdjustmentOrder.four_px', dm: '推送库存调整单' }),
    value: '1',
  },

  {
    label: $i18n.get({ id: 'CancelInventoryAdjustmentOrder.four_px', dm: '取消库存调整单' }),
    value: '2',
  },
];

// 拣货下架单号
const PICKING_ORDER = [
  {
    label: $i18n.get({ id: 'AgvPickingOffShelfOrder.four_px', dm: 'AGV拣货下架订单' }),
    value: 'agvNos',
  },

  {
    label: $i18n.get({ id: 'PickingJobNo.four_px', dm: '拣选作业单号' }),
    value: 'jobNos',
  },

  {
    label: $i18n.get({ id: 'CKDDH.OutboundOrderNo.four_px', dm: '出库订单号' }),
    value: 'consignmentNos',
  },

  {
    label: $i18n.get({ id: 'TotalNumberOfAgvJobs.four_px', dm: 'AGV作业总单号' }),
    value: 'customJobNos',
  },
];

// 拣选sku
const PICKING_SKU_TYPE = [
  {
    label: 'SKU ID',
    value: 'skuIds',
  },

  {
    label: $i18n.get({ id: 'SkuEncoding.four_px', dm: 'SKU编码' }),
    value: 'skuCodes',
  },
];

// 拣选下架时间
const PICKING_TIME = [
  {
    label: $i18n.get({ id: 'Created.four_px', dm: '创建时间' }),
    value: 'createTime',
  },

  {
    label: $i18n.get({ id: 'CompletionTime.four_px', dm: '完成时间' }),
    value: 'completeTime',
  },

  {
    label: $i18n.get({ id: 'EstimatedOutboundTime.four_px', dm: '预计出库时间' }),
    value: 'expectedOutboundTime',
  },
];

// 拣选人
const PICKING_PERSON = [
  {
    label: $i18n.get({ id: 'Founder.four_px', dm: '创建人' }),
    value: 'creatorCode',
  },

  {
    label: $i18n.get({ id: 'Operator.four_px', dm: '操作人' }),
    value: 'operatorCode',
  },
];

// 是否合单
const IS_MERGE = [
  // {
  //   label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
  //   value: '',
  // },

  {
    label: $i18n.get({ id: 'CombinedOrder.four_px', dm: '合单' }),
    value: 'Y',
  },

  {
    label: $i18n.get({ id: 'NonConforming.four_px', dm: '不合单' }),
    value: 'N',
  },
];

// AGV拣货TAB
const PICKING_TAB_STATUS = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: $i18n.get({ id: 'ToBeSelected.four_px', dm: '待拣选' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'Picking.four_px', dm: '拣选中' }),
    value: 'G',
  },

  {
    label: $i18n.get({ id: 'YJX.Selected.four_px', dm: '已拣选' }),
    value: 'F',
  },

  {
    label: $i18n.get({ id: 'Canceled.four_px', dm: '已取消' }),
    value: 'X',
  },
];

// 拣货详情状态
const PICKING_DETAIL_STATUS = [
  {
    label: $i18n.get({ id: 'Normal.four_px', dm: '正常' }),
    value: 'Y',
  },

  {
    label: $i18n.get({ id: 'QH.OutOfStock.four_px', dm: '缺货' }),
    value: 'N',
  },
];

// 移库上架单号
const MOVE_ORDER = [
  {
    label: $i18n.get({ id: 'AgvStorageAndShelvingOrder.four_px', dm: 'AGV移库上架订单' }),
    value: 'agvNo',
  },

  {
    label: $i18n.get({ id: 'MigrationJob.four_px', dm: '移库作业单' }),
    value: 'jobNo',
  },
];

// 移库上架单号
const MOVE_DOWN_ORDER = [
  {
    label: $i18n.get({ id: 'AgvStorageRemovalOrder.four_px', dm: 'AGV移库下架订单' }),
    value: 'agvNo',
  },

  {
    label: $i18n.get({ id: 'MigrationJob.four_px', dm: '移库作业单' }),
    value: 'jobNo',
  },
];

// 移库上架单tab
const MOVE_TAB_STATUS = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: $i18n.get({ id: 'InProgress.four_px', dm: '进行中' }),
    value: 'G',
  },

  {
    label: $i18n.get({ id: 'Completed.four_px', dm: '已完成' }),
    value: 'F',
  },

  {
    label: $i18n.get({ id: 'Cancel.four_px', dm: '取消' }),
    value: 'X',
  },
];

// 移库上架单table
const MOVE_TABLE_STATUS = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: $i18n.get({ id: 'InProgress.four_px', dm: '进行中' }),
    value: 'G',
  },

  {
    label: $i18n.get({ id: 'Completed.four_px', dm: '已完成' }),
    value: 'F',
  },

  {
    label: $i18n.get({ id: 'Canceled.four_px', dm: '已取消' }),
    value: 'X',
  },
];

// 移库上架时间
const MOVE_TIME = [
  {
    label: $i18n.get({ id: 'Created.four_px', dm: '创建时间' }),
    value: 'agvCreateTime',
  },

  {
    label: $i18n.get({ id: 'CompletionTime.four_px', dm: '完成时间' }),
    value: 'agvCompleteTime',
  },
];

// agv sku
// 推送状态
const PUSH_STATUS = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: 'all',
  },

  {
    label: $i18n.get({ id: 'PushedSuccessfully.four_px', dm: '推送成功' }),
    value: 0,
  },

  {
    label: $i18n.get({ id: 'PushFailed.four_px', dm: '推送失败' }),
    value: -1,
  },
];

// 推送类型
const PUSH_TYPE = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: 'all',
  },

  {
    label: $i18n.get({ id: 'Add.four_px', dm: '新增' }),
    value: 'ADD',
  },

  {
    label: $i18n.get({ id: 'Update.four_px', dm: '更新' }),
    value: 'UPDATE',
  },
];

const SKU_PUSH_NODE = [
  {
    label: $i18n.get({ id: 'WarehouseReceiptReview.four_px', dm: '入库单审核' }),
    value: 'Receipt',
  },

  {
    label: $i18n.get({ id: 'Receipt.four_px', dm: '收货' }),
    value: 'Putaway',
  },

  {
    label: $i18n.get({ id: 'CreateAnAgvLibrary.four_px', dm: '创建AGV移库上架' }),
    value: 'Move-putaway',
  },

  {
    label: $i18n.get({ id: 'RePush.four_px', dm: '重推' }),
    value: 'Retry',
  },
];

const SKU_PUSH_STYLE = [
  {
    label: $i18n.get({ id: 'Automatic.four_px', dm: '自动' }),
    value: 'normal',
  },

  {
    label: $i18n.get({ id: 'Manual.four_px', dm: '手动' }),
    value: 'hand',
  },
];

const SKU_PUSH_RESULT = [
  {
    label: $i18n.get({ id: 'Success.four_px', dm: '成功' }),
    value: true,
  },

  {
    label: $i18n.get({ id: 'SB.Failed.four_px', dm: '失败' }),
    value: false,
  },
];

// 推送AGV
const PUSH_AGV = [
  {
    label: $i18n.get({ id: 'Rookie.four_px', dm: '菜鸟' }),
    value: 'CAGV',
  },

  {
    label: $i18n.get({ id: 'FastWarehouse.four_px', dm: '快仓' }),
    value: 'KAGV',
  },
];

// 手工汇波是否合单
const IS_MERGES = [
  {
    label: $i18n.get({ id: 'CombinedOrder.four_px', dm: '合单' }),
    value: 'Y',
  },

  {
    label: $i18n.get({ id: 'NonConforming.four_px', dm: '不合单' }),
    value: 'N',
  },
];

// 手工汇波增值服务分段
const AGV_OPERATE_PERIOD = [
  {
    label: $i18n.get({ id: 'ValueAddedSegmentsInTheDatabase.four_px', dm: '库内增值段' }),
    value: 'WH',
  },

  {
    label: $i18n.get({ id: 'ReturnValueAddedSegment.four_px', dm: '退件增值段' }),
    value: 'RM',
  },
];

// 手工汇波增值服务类型
const AGV_OPERATE_TYPE = [
  {
    label: $i18n.get({ id: 'UnpackingAndShelving.four_px', dm: '拆箱上架' }),
    value: 'UP',
  },

  {
    label: $i18n.get({ id: 'APairAHuanBiao.four_px', dm: '一对一换标' }),
    value: 'OTOC',
  },

  {
    label: $i18n.get({ id: 'ClosedBoxShelving.four_px', dm: '合箱上架' }),
    value: 'BP',
  },
];

// AGV理货
const TALLY_NO_TYPE = [
  {
    label: $i18n.get({ id: 'AgvTallyWorkSheet.four_px', dm: 'AGV理货作业单' }),
    value: 'jobNo',
  },

  {
    label: $i18n.get({ id: 'AgvTallyOrder.four_px', dm: 'AGV理货订单' }),
    value: 'agvNo',
  },
];

const TALLY_TYPE = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: 'all',
  },

  {
    label: $i18n.get({ id: 'MergeLocations.four_px', dm: '合并库位' }),
    value: 'R',
  },

  {
    label: $i18n.get({ id: 'LocationArrangement.four_px', dm: '整理库位' }),
    value: 'M',
  },
];

const TALLY_TIME = [
  {
    label: $i18n.get({ id: 'Created.four_px', dm: '创建时间' }),
    value: 'createTime',
  },

  {
    label: $i18n.get({ id: 'CompletionTime.four_px', dm: '完成时间' }),
    value: 'completeTime',
  },
];

const TALLY_PERSON_TYPE = [
  {
    label: $i18n.get({ id: 'Founder.four_px', dm: '创建人' }),
    value: 'creator',
  },

  {
    label: $i18n.get({ id: 'Operator.four_px', dm: '操作人' }),
    value: 'operator',
  },
];

const TALLY_DETAIL_TYPE = [
  {
    label: $i18n.get({ id: 'TallyOffTheShelf.four_px', dm: '理货下架' }),
    value: 'D',
  },

  {
    label: $i18n.get({ id: 'TallyOnShelves.four_px', dm: '理货上架' }),
    value: 'P',
  },
];

/**
 * agv 库存异常
 */
const AGV_ABNOR_ORDER = [
  {
    label: $i18n.get({ id: 'AgvExceptionSerialNumber.four_px', dm: 'AGV异常流水号' }),
    value: 'agvHistoryNo',
  },

  {
    label: $i18n.get({ id: 'AgvExceptionNumber.four_px', dm: 'AGV异常单号' }),
    value: 'customExceptionNo',
  },
];

const AGV_ABNOR_PERSON = [
  {
    label: $i18n.get({ id: 'Founder.four_px', dm: '创建人' }),
    value: 'creatorCode',
  },

  {
    label: $i18n.get({ id: 'Operator.four_px', dm: '操作人' }),
    value: 'operatorCode',
  },
];

const AGV_ABNOR_TIME = [
  {
    label: $i18n.get({ id: 'Created.four_px', dm: '创建时间' }),
    value: 'createTime',
  },

  {
    label: $i18n.get({ id: 'OperationTime.four_px', dm: '操作时间' }),
    value: 'completeTime',
  },
];

const AGV_ABNOR_STATUS = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: 'all',
  },

  {
    label: $i18n.get({ id: 'PendingReview.four_px', dm: '待审核' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'Completed.four_px', dm: '已完成' }),
    value: 'C',
  },
];

/*
 * 库存调整
 */
// 库存调整类型
const INVENTORY_ADJUST_TYPE = [
  {
    label: $i18n.get({ id: 'InventoryAdjustment.four_px', dm: '库存调整' }),
    value: 'N',
  },

  {
    label: $i18n.get({ id: 'KWTZ.LocationAdjustment.four_px', dm: '库位调整' }),
    value: 'L',
  },
];

// 库存调整原因R：退货；T：转货；O：操作错误；M：丢货赔付
const INVENTORY_ADJUST_REASON = [
  {
    label: $i18n.get({ id: 'Return.four_px', dm: '退货' }),
    value: 'R',
  },

  {
    label: $i18n.get({ id: 'Transfer.four_px', dm: '转货' }),
    value: 'T',
  },

  {
    label: $i18n.get({ id: 'OperationError.four_px', dm: '操作错误' }),
    value: 'O',
  },

  {
    label: $i18n.get({ id: 'LossCompensation.four_px', dm: '丢货赔付' }),
    value: 'M',
  },

  {
    label: $i18n.get({ id: 'KWTZ.LocationAdjustment.four_px', dm: '库位调整' }),
    value: 'AL',
  },
];

const AMR_PACKING_SHELF_TAB_STATUS = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: $i18n.get({ id: 'ToBeSelected.four_px', dm: '待拣选' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'Picking.four_px', dm: '拣选中' }),
    value: 'G',
  },

  {
    label: $i18n.get({ id: 'YJX.Selected.four_px', dm: '已拣选' }),
    value: 'F',
  },

  {
    label: $i18n.get({ id: 'Canceled.four_px', dm: '已取消' }),
    value: 'X',
  },
];

// 操作内容
const AMR_PACKING_SHELF_OPERATION_NODE = [
  {
    label: $i18n.get({ id: 'ReceiveAgvOrderFeedback.four_px', dm: '接收AGV订单反馈' }),
    value: '0',
  },

  {
    label: $i18n.get({ id: 'PushAgvOrders.four_px', dm: '推送AGV订单' }),
    value: '1',
  },

  {
    label: $i18n.get({ id: 'CancelAnAgvOrder.four_px', dm: '取消AGV订单' }),
    value: '2',
  },

  {
    label: $i18n.get({ id: 'CancelAgvRejection.four_px', dm: 'AGV拒单取消' }),
    value: '3',
  },

  {
    label: $i18n.get({ id: 'CustomerCancelsAgvOrder.four_px', dm: '客户取消AGV订单' }),
    value: '4',
  },

  {
    label: $i18n.get({ id: 'CancelAgvRejection.four_px', dm: 'AGV拒单取消' }),
    value: '5',
  },
];

// 拣选下架时间
const AMR_PACKING_SHELF_TIME = [
  {
    label: $i18n.get({ id: 'Created.four_px', dm: '创建时间' }),
    value: 'createTime',
  },

  {
    label: $i18n.get({ id: 'CompletionTime.four_px', dm: '完成时间' }),
    value: 'completeTime',
  },

  {
    label: $i18n.get({ id: 'EstimatedOutboundTime.four_px', dm: '预计出库时间' }),
    value: 'expectedOutboundTime',
  },
];

const AMR_PACKING_SHELF_NOS = [
  {
    label: $i18n.get({ id: 'PickingJobNo.four_px', dm: '拣选作业单号' }),
    value: 'jobNos',
  },

  {
    label: $i18n.get({ id: 'PickOffTheShelfOrder', dm: '拣选下架订单' }),
    value: 'agvNos',
  },
];

const AMR_SKU_TYPE = [
  {
    label: 'SKU ID',
    value: 'skuIds',
  },

  {
    label: $i18n.get({ id: 'sku_code', dm: 'SKU编码' }),
    value: 'skuCodes',
  },
];

const AMR_PACKING_SHELF_PERSON_TYPE = [
  {
    label: $i18n.get({ id: 'Founder.four_px', dm: '创建人' }),
    value: 'creatorCode',
  },

  {
    label: $i18n.get({ id: 'Operator.four_px', dm: '操作人' }),
    value: 'operatorCode',
  },
];

// 推送状态
const AMR_PACKING_SHELF_PLUSH_STATUS = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: $i18n.get({ id: 'PushedSuccessfully.four_px', dm: '推送成功' }),
    value: '0',
  },

  {
    label: $i18n.get({ id: 'PushFailed.four_px', dm: '推送失败' }),
    value: '1',
  },

  {
    label: $i18n.get({ id: 'FeedbackSuccessful.four_px', dm: '反馈成功' }),
    value: '3',
  },

  {
    label: $i18n.get({ id: 'FeedbackFailed.four_px', dm: '反馈失败' }),
    value: '4',
  },
];

// AGV服务名
const AGV_SERVICE = 'giws-agv';

const GIWS_AUTO = 'auto';

export {
  RECEIVING_TIME,
  RECEIVING_TAB_STATUS,
  RECEIVING_ORDER,
  RECEIVING_PERSON_TYPE,
  RECEIVING_PUSH_STATUS,
  RECEIVING_OPERATION_NODE,
  STOCK_ADJUST_OPERATION_NODE,
  PICKING_ORDER,
  PICKING_SKU_TYPE,
  PICKING_TIME,
  PICKING_TAB_STATUS,
  PICKING_DETAIL_STATUS,
  PICKING_PERSON,
  IS_MERGE,
  MOVE_ORDER,
  MOVE_DOWN_ORDER,
  MOVE_TAB_STATUS,
  MOVE_TABLE_STATUS,
  MOVE_TIME,
  AGV_SERVICE,
  PUSH_STATUS,
  PUSH_TYPE,
  PUSH_AGV,
  SKU_PUSH_NODE,
  SKU_PUSH_STYLE,
  SKU_PUSH_RESULT,
  IS_MERGES,
  TALLY_NO_TYPE,
  TALLY_TYPE,
  TALLY_TIME,
  TALLY_PERSON_TYPE,
  TALLY_DETAIL_TYPE,
  AGV_ABNOR_ORDER,
  AGV_ABNOR_PERSON,
  AGV_ABNOR_TIME,
  AGV_ABNOR_STATUS,
  INVENTORY_ADJUST_TYPE,
  INVENTORY_ADJUST_REASON,
  AGV_OPERATE_PERIOD,
  AGV_OPERATE_TYPE,
  AMR_PACKING_SHELF_NOS,
  AMR_PACKING_SHELF_TIME,
  AMR_PACKING_SHELF_PERSON_TYPE,
  AMR_SKU_TYPE,
  AMR_PACKING_SHELF_PLUSH_STATUS,
  GIWS_AUTO,
  AMR_PACKING_SHELF_OPERATION_NODE,
  AMR_PACKING_SHELF_TAB_STATUS,
};
